export default __webpack_public_path__ + "static/media/icon-checked.67b5434a.webp";